import { OfflineDatabaseBrandGeneralSettings } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseBrandGeneralSettings.types';
import { offlineBrandGeneralSettingsRepository } from '../../../../../../../repositories/offlineBrandGeneralSettings.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';
import { FindBrandGeneralSettingsToOfflineOutput } from './types/brandGeneralSettingsQueryKeysAndFnGenerator.types';

export class BrandGeneralSettingsQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindBrandGeneralSettingsToOfflineOutput>({
      url: '/brands/general-settings/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineBrandGeneralSettingsRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(
    data: FindBrandGeneralSettingsToOfflineOutput,
  ): OfflineDatabaseBrandGeneralSettings {
    return {
      id: data.id,
      brandId: data.brandId,
      restrictProductsUsingCustomerCatalogs: data.restrictProductsUsingCustomerCatalogs,
    };
  }
}
